/* eslint-disable quotes */
/* eslint-disable linebreak-style */
export default {
  PROFILE: 'PROFILE',
  UPDATE_PROFILE: 'UPDATE_PROFILE',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  CLEAR_ACCOUNT_MESSAGE: 'CLEAR_ACCOUNT_MESSAGE',
  CLEAR_ACCOUNT_PROPS: 'CLEAR_ACCOUNT_PROPS',
  LOGIN: 'LOGIN',
  TOKEN_LOGIN: 'TOKEN_LOGIN',
  LOGOUT: 'LOGOUT',
  SEND_OTP: 'SEND_OTP',
  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_TOKEN_VERIFY: 'RESET_TOKEN_VERIFY',
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',
  CLEAR_AUTH_PROPS: 'CLEAR_AUTH_PROPS',
  CMS_LIST: 'CMS_LIST',
  CMS_DETAILS: 'CMS_DETAILS',
  EDIT_CMS_DETAILS: 'EDIT_CMS_DETAILS',
  DELETE_CMS_DETAILS: 'DELETE_CMS_DETAILS',
  ADD_CMS_DETAILS: 'ADD_CMS_DETAILS',
  CLEAR_CMS_MESSAGE: 'CLEAR_CMS_MESSAGE',
  CLEAR_USER_PROPS: 'CLEAR_USER_PROPS',
  CONTEST_LIST: 'CONTEST_LIST',
  CONTEST_DETAILS: 'CONTEST_DETAILS',
  WINNING_PATTERN_LIST: 'WINNING_PATTERN_LIST',
  ADMIN_WINNING_PATTERN_LIST: 'ADMIN_WINNING_PATTERN_LIST',
  ADD_CONTEST: 'ADD_CONTEST',
  EDIT_CONTEST: 'EDIT_CONTEST',
  USER_CONTEST_LIST: 'USER_CONTEST_LIST',
  CLEAR_CONTEST_MESSAGE: 'CLEAR_CONTEST_MESSAGE',
  CLEAR_CONTEST_PROPS: 'CLEAR_CONTEST_PROPS',
  FEEDBACK_LIST: 'FEEDBACK_LIST',
  UPDATE_STATUS: 'UPDATE_STATUS',
  FEEDBACK_DETAILS: 'FEEDBACK_DETAILS',
  DELETE_FEEDBACK: 'DELETE_FEEDBACK',
  CLEAR_FEEDBACK_MESSAGE: 'CLEAR_FEEDBACK_MESSAGE',
  CLEAR_FEEDBACK_PROPS: 'CLEAR_FEEDBACK_PROPS',
  SEND_NOTIFICATION: 'SEND_NOTIFICATION',
  NOTIFICATION_TYPES: 'NOTIFICATION_TYPES',
  CLEAR_NOTIFICATION_MESSAGE: 'CLEAR_NOTIFICATION_MESSAGE',
  CLEAR_NOTIFICATION_PROPS: 'CLEAR_NOTIFICATION_PROPS',
  PROMOCODE_LIST: 'PROMOCODE_LIST',
  ADD_PROMOCODE: 'ADD_PROMOCODE',
  PROMOCODE_DETAILS: 'PROMOCODE_DETAILS',
  UPDATE_PROMOCODE: 'UPDATE_PROMOCODE',
  DELETE_PROMOCODE: 'DELETE_PROMOCODE',
  CLEAR_PROMOCODE_MESSAGE: 'CLEAR_PROMOCODE_MESSAGE',
  CLEAR_PROMOCODE_PROPS: 'CLEAR_PROMOCODE_PROPS',
  QUESTION_LIST: 'QUESTION_LIST',
  ADD_QUESTION: 'ADD_QUESTION',
  DELETE_QUESTION: 'DELETE_QUESTION',
  EDIT_QUESTION: 'EDIT_QUESTION',
  UPLOAD_FILE: 'UPLOAD_FILE',
  QUESTION_DETAILS: 'QUESTION_DETAILS',
  CLEAR_QUESTION_MESSAGE: 'CLEAR_QUESTION_MESSAGE',
  CLEAR_QUESTION_PROPS: 'CLEAR_QUESTION_PROPS',
  ADD_SUBADMIN: 'ADD_SUBADMIN',
  PERMISSION_LIST: 'PERMISSION_LIST',
  CLEAR_SUBADMIN_MESSAGE: 'CLEAR_SUBADMIN_MESSAGE',
  CLEAR_SUBADMIN_PROPS: 'CLEAR_SUBADMIN_PROPS',
  THEME_LIST: 'THEME_LIST',
  THEME_LIST_FOR_SELECTION: 'THEME_LIST_FOR_SELECTION',
  THEME_DETAILS: 'THEME_DETAILS',
  ADD_THEME: 'ADD_THEME',
  UPDATE_THEME: 'UPDATE_THEME',
  CLEAR_THEME_MESSAGE: 'CLEAR_THEME_MESSAGE',
  CLEAR_THEME_PROPS: 'CLEAR_THEME_PROPS',
  USER_LIST: 'USER_LIST',
  ADD_USER: 'ADD_USER',
  USER_DETAILS: 'USER_DETAILS',
  UPDATE_USER_DETAILS: 'UPDATE_USER_DETAILS',
  UPDATE_BANK_DETAILS: 'UPDATE_BANK_DETAILS',
  UPDATE_KYC_DETAILS: 'UPDATE_KYC_DETAILS',
  UPDATE_PROFILE_PICTURE: 'UPDATE_PROFILE_PICTURE',
  KYC_LIST: 'KYC_LIST',
  UPDATE_KYC_STATUS: 'UPDATE_KYC_STATUS',
  CLEAR_USER_MESSAGE: 'CLEAR_USER_MESSAGE',
  ADD_USER_CONTEST: 'ADD_USER_CONTEST',
  USER_CONTEST_DETAILS: 'USER_CONTEST_DETAILS',
  EDIT_USER_CONTEST: 'EDIT_USER_CONTEST',
  CLEAR_USER_CONTEST_MESSAGE: 'CLEAR_USER_CONTEST_MESSAGE',
  CLEAR_USER_CONTEST_PROPS: 'CLEAR_USER_CONTEST_PROPS',
  GET_JOINED_USERS_LIST: 'GET_JOINED_USERS_LIST',
  GET_JOINED_USER_DETAILS: 'GET_JOINED_USER_DETAILS',
  GET_JOINED_USER_TICKETS: 'GET_JOINED_USER_TICKETS',
  GET_JOINED_USER_ANSWERS: 'GET_JOINED_USER_ANSWERS',
  WRITE_PERMISSION: 'W',
  READ_PERMISSION: 'R',
  LIMITED_ACCESS_PERMISSION: 'LA',
  NO_PERMISSION: 'N',
  CLEAR_BANNER_MESSAGE: 'CLEAR_BANNER_MESSAGE',
  ADD_BANNER: 'ADD_BANNER',
  BANNER_LIST: 'BANNER_LIST',
  BANNER_DETAILS: 'BANNER_DETAILS',
  UPDATE_BANNER: 'UPDATE_BANNER',
  CALCULATE_PRIZE_DISTRIBUTION: 'CALCULATE_PRIZE_DISTRIBUTION',
  CONFIRM_PRIZE_DISTRIBUTION: 'CONFIRM_PRIZE_DISTRIBUTION',
  PROCESS_REFUND: 'PROCESS_REFUND',
  EXPORT_USER_CONTEST_DATA: 'EXPORT_USER_CONTEST_DATA',
  CLEAR_USER_CONTEST_EXPORT_DATA: 'CLEAR_USER_CONTEST_EXPORT_DATA',
  EXPORT_CONTEST_DATA: 'EXPORT_CONTEST_DATA',
  CLEAR_CONTEST_EXPORT_DATA: 'CLEAR_CONTEST_EXPORT_DATA',
  EXPORT_KYC_DATA: 'EXPORT_KYC_DATA',
  CLEAR_KYC_EXPORT_DATA: 'CLEAR_KYC_EXPORT_DATA',
  EXPORT_USER_DATA: 'EXPORT_USER_DATA',
  CLEAR_USER_EXPORT_DATA: 'CLEAR_USER_EXPORT_DATA',
  GET_USER_CONTEST_STATS: "GET_USER_CONTEST_STATS",
  GET_USER_COUNT_STATS: "GET_USER_COUNT_STATS",
  GET_USER_BALANCE_STATS: "GET_USER_BALANCE_STATS",
  GET_USER_REGISTER_STATS: "GET_USER_REGISTER_STATS",
  GET_WITHDRAW_REQ_LIST: "GET_WITHDRAW_REQ_LIST",
  HANDLE_WITHDRAW_REQ: "HANDLE_WITHDRAW_REQ",
  CLEAR_WITHDRAWAL_EXPORT_DATA: "CLEAR_WITHDRAWAL_EXPORT_DATA",
  CLEAR_WITHDRAW_MESSAGE: "CLEAR_WITHDRAW_MESSAGE",
  EXPORT_WITHDRAW_DATA: "EXPORT_WITHDRAW_DATA",
  GET_SUBADMIN_LIST: "GET_SUBADMIN_LIST",
  CLEAR_SUBADMIN_EXPORT_DATA: "CLEAR_SUBADMIN_EXPORT_DATA",
  SUB_ADMIN_DETAILS: "SUB_ADMIN_DETAILS",
  GET_SUB_ADMIN_DETAILS: "GET_SUB_ADMIN_DETAILS",
  EDIT_SUBADMIN: "EDIT_SUBADMIN",
  GET_USER_TRANSACTION_LIST: "GET_USER_TRANSACTION_LIST",
  EXPORT_USER_TRANSACTION_DATA: 'EXPORT_USER_TRANSACTION_DATA',
  CLEAR_USER_TRANSACTION_EXPORT_DATA: 'CLEAR_USER_TRANSACTION_EXPORT_DATA',
  GET_USER_DEPOSIT_LIST: "GET_USER_DEPOSIT_LIST",
  EXPORT_USER_DEPOSIT_DATA: 'EXPORT_USER_DEPOSIT_DATA',
  CLEAR_USER_DEPOSIT_EXPORT_DATA: 'CLEAR_USER_DEPOSIT_EXPORT_DATA',
  GET_USER_HEART_LIST: "GET_USER_HEART_LIST",
  EXPORT_USER_HEART_DATA: 'EXPORT_USER_HEART_DATA',
  CLEAR_USER_HEART_EXPORT_DATA: 'CLEAR_USER_HEART_EXPORT_DATA',
  EXPORT_GENERAL_SETTING_DATA: 'EXPORT_GENERAL_SETTING_DATA',
  GENERAL_SETTING_LIST: 'GENERAL_SETTING_LIST',
  CLEAR_GENERAL_SETTING_EXPORT_DATA: 'CLEAR_GENERAL_SETTING_EXPORT_DATA',
  GENERAL_SETTING_DETAILS: 'GENERAL_SETTING_DETAILS',
  CLEAR_GENERAL_SETTING_MESSAGE: 'CLEAR_GENERAL_SETTING_MESSAGE',
  EDIT_GENERAL_SETTING: 'EDIT_GENERAL_SETTING',
  AMOUNT_DEPOSIT: 'AMOUNT_DEPOSIT',
  GET_TURNOVER_STATS: 'GET_TURNOVER_STATS',
  GET_PROFIT_STATS: 'GET_PROFIT_STATS',
  GET_REPORT: 'GET_REPORT',
  CLEAR_REPORTS_DATA: 'CLEAR_REPORTS_DATA',
  CLEAR_REPORTS_MESSAGE: 'CLEAR_REPORTS_MESSAGE',
  GET_WINNERS_LIST: "GET_WINNERS_LIST",
  UPDATE_DEPOSIT_TRANSACTION_STATUS: "UPDATE_DEPOSIT_TRANSACTION_STATUS",
  GET_DEBUGGER_DETAILS: "GET_DEBUGGER_DETAILS",
  ADD_ADMIN_USER :'ADD_ADMIN_USER',
  UPDATE_USER : 'UPDATE_USER'
}
